<div class="col element-zoom m-0 pointer-events-none" [ngStyle]="contentStyle">
  <div class="widget-wrapper open" [ngStyle]="borderStyle" style="min-height: 100%">
    <div class="form-wrapper">
      @for (field of widgetConfig.attributes['field_attributes']; track field.name) {
      <div class="form-group custom-calender">
        <!-- Date picker -->
        @if (dateType === datePickerTypes.DATEPICKER) {
        <form [formGroup]="birthdayForm">
          <finxone-datepicker
            [dateFormat]="datePickerTypes.DATEPICKER"
            [id]="'dob'"
            [formControlName]="'dob'"
            [placeholder]="'Select date of birthday'"
          ></finxone-datepicker>

          @if (isError) {
          <div class="error-wrapper">
            <div class="text-error mt-1">
              <p>You need to be at least {{ minAge }} years old to meet the criteria.</p>
            </div>
          </div>
          }
        </form>
        }

        <!-- Input date fields -->
        @if (dateType === datePickerTypes.INPUT) {
        <div
          #dateGroup
          class="bithday-form is-center show-date-picker-input"
          [formGroup]="inputFieldsDateForm"
          (focusout)="onDateGroupFocusOut($event, monthDropdown.isOpen)"
        >
          <div class="mr-4 flex-1">
            <finxone-input
              class="block w-full"
              [inputMode]="'decimal'"
              type="number"
              [label]="'Day'"
              [formControlName]="'day'"
              [id]="'day'"
              [disableAutocomplete]="disableAutocomplete"
              [formControlInvalid]="
                  !!(isDateGroupTouched && inputFieldsDateForm?.controls?.['day']?.invalid)
                "
              [value]="inputFieldsDateForm?.get('day')?.value ?? ''"
            >
            </finxone-input>
          </div>

          <div class="mr-4 month-dropdown flex-1">
            <finxone-select-dropdown
              #monthDropdown
              class="block w-full"
              [label]="'Month'"
              [formControlName]="'month'"
              [id]="'month'"
              [optionLabelKey]="'name'"
              [optionValueKey]="'key'"
              [options]="allMonths"
              [appendToBody]="true"
              [isScrollable]="isScrollable"
              [isScrollPeekEnabled]="isScrollPeekEnabled"
              [visibleItemsCount]="visibleItemsCount"
              [menuDirection]="menuDirection"
              [selectedOption]="selectedMonthValue?.name ?? ''"
            >
            </finxone-select-dropdown>
          </div>
          <div class="flex-1">
            <finxone-input
              class="block w-full"
              [inputMode]="'decimal'"
              type="number"
              [label]="'Year'"
              [maxLength]="4"
              [formControlName]="'year'"
              [id]="'year'"
              [disableAutocomplete]="disableAutocomplete"
              [formControlInvalid]="
                  !!(isDateGroupTouched && inputFieldsDateForm?.controls?.['year']?.invalid)
                "
              [value]="inputFieldsDateForm?.get('year')?.value ?? ''"
            >
            </finxone-input>
          </div>
        </div>
        }

        <!-- Input validation -->
        @if (getInputDateError(inputFieldsDateForm)) {
        <div class="text-error typog-xs mt-1">{{ getInputDateError(inputFieldsDateForm) }}</div>
        }
        <!-- Parent form validation -->
        @else if (birthdayForm?.get('dob')?.invalid && birthdayForm?.get('dob')?.touched &&
        birthdayForm?.get('dob')?.hasError('required')) {
        <div class="text-error typog-xs mt-1">{{ validationMessages.required(dateOfBirthLabel) }}</div>
        }
      </div>
      }
    </div>
  </div>
</div>
